import React from 'react'

import logoAuteco from './../../UI/logos/logo-auteco.svg'

interface Props{
    isLoading: boolean
}

interface State{}

class LoadingMobile extends React.Component<Props,State>{
    constructor(props: Props){
        super(props)
    }

    render(){
        return(
            <div className={this.props.isLoading ? "loading-div-mobile fade-in":"loading-div-mobile fade-out"}>
                <img src={logoAuteco} className='logo-auteco-mobile' alt=''/>
                <svg className="loader-circle-mobile" viewBox="0 0 150 150" xmlns="http://www.w3.org/2000/svg">
                    <circle className= 'internal-circle-mobile' cx="75" cy="75" r="70"></circle>
                </svg>
                <svg className="loader-circle-over-mobile" viewBox="0 0 150 150" xmlns="http://www.w3.org/2000/svg">
                    <circle className= 'internal-circle-over-mobile' cx="75" cy="75" r="70"></circle>
                </svg>
            </div>
        )
    }
}

export default LoadingMobile